import {Customer} from '../customer.model';
import {CustomerContact} from '../customer-contact.model';
import {CustomerCharacteristic} from '../customer-characteristic.model';
import {CustomerIdentification} from '../customer-identification.model';
import {CustomerAddress} from '../customer-address.model';
import { Vehicle } from '../vehicle.model';
import { Dictionary } from '../../../shared/models/dictionary.model';

export class CommonDetailViewModel extends Customer {

    public statusTypeId: number;

    public photo: any;

    public signature: any;

    public contacts: CustomerContact[];

    public characteristics: CustomerCharacteristic[];

    public identifications: CustomerIdentification[];

    public addresses: CustomerAddress[];

    public physicalAddress: CustomerAddress;

    public mailingAddress: CustomerAddress;

    public vehicles: Vehicle[];
    public override: boolean;

    public accessControls: Dictionary;

    public curbSideDelivery: boolean;

    constructor() {
        super();

        this.contacts = new Array();
        this.characteristics = new Array();
        this.identifications = new Array();
        this.addresses = new Array();
        this.vehicles = new Array();
        this.accessControls = new Dictionary([]);
    }
}
